import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Container,
  Nav,
  NavDropdown,
  Navbar,
  ProgressBar,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useTranslation } from "react-i18next";

export default function NavComponent({ userData, enablePhases }) {
  const { t } = useTranslation();
  const location = useLocation();
  const [docsRequired, setDocsRequired] = useState();

  const getActivePage = (pageTitle) => {
    if (location.pathname.includes(pageTitle)) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (userData && userData.documents) {
      if (userData.documents.documents) {
        let documentCollection = userData.documents.documents;
        let totalRequiredDocs = 4;

        if (documentCollection.driverLicense || documentCollection.stateId)
          totalRequiredDocs--;
        if (documentCollection.passport || documentCollection.birthCertificate || documentCollection.socialSecurityCard)
          totalRequiredDocs--;
        if (documentCollection.tbTest)
          totalRequiredDocs--;
        if (documentCollection.covidVaccine)
          totalRequiredDocs--;
        setDocsRequired(totalRequiredDocs);
      }
    }
  });

  return (
    <aside>
      <Navbar
        collapseOnSelect
        expand="lg"
        bg=""
        variant=""
        className="fixed flex-lg-column text-lg-start"
      >
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="flex-column" navbarScroll>
            {/* Phase 1  */}
            <section style={{ marginTop: "1rem" }}>
              <p>{t("nav.phase1")}</p>
              <LinkContainer to={"welcome"}>
                <Nav.Link
                  active={getActivePage("welcome")}
                  className="complete"
                >
                  {t("nav.welcome")}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer
                to={"phase1-personal-information"}
                disabled={!userData.username ? true : false}
              >
                <Nav.Link
                  active={getActivePage("personal-information")}
                  className={userData.empInfo ? "complete" : "in-progress"}
                >
                  {t("nav.personalInformation")}
                </Nav.Link>
              </LinkContainer>
            </section>

            {/* Phase 2  */}
            <section>
              <p className={enablePhases.phase2 ? "" : "phase-disabled"}>
                {t("nav.phase2")}
              </p>
              <LinkContainer
                to={"phase2-general"}
                disabled={enablePhases.phase2 ? false : true}
              >
                <Nav.Link
                  active={getActivePage("general")}
                  className={userData.general ? "complete" : "in-progress"}
                >
                  {t("nav.generalInformation")}
                </Nav.Link>
              </LinkContainer>

              <LinkContainer
                to={"phase2-residences"}
                disabled={enablePhases.phase2 ? false : true}
              >
                <Nav.Link
                  active={getActivePage("residences")}
                  className={
                    userData.residenceInfo
                      ? "complete"
                      : "in-progress"
                  }
                >
                  {t("nav.residenceHistory")}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer
                to={"phase2-employers"}
                disabled={enablePhases.phase2 ? false : true}
              >
                <Nav.Link
                  active={getActivePage("employers")}
                  className={
                    userData.employment
                      ? "complete"
                      : "in-progress"
                  }
                >
                  {t("nav.employmentHistory")}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer
                to={"phase2-references"}
                disabled={enablePhases.phase2 ? false : true}
              >
                <Nav.Link
                  active={getActivePage("references")}
                  className={
                    userData.referenceInfo &&
                    userData.referenceInfo.references &&
                    userData.referenceInfo.references.length >= 2
                      ? "complete"
                      : "in-progress"
                  }
                >
                  {t("nav.references")}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer
                to={"phase2-education"}
                disabled={enablePhases.phase2 ? false : true}
              >
                <Nav.Link
                  active={getActivePage("education")}
                  className={
                    userData.education
                      ? "complete"
                      : "in-progress"
                  }
                >
                  {t("nav.education")}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer
                to={"phase2-background-information"}
                disabled={enablePhases.phase2 ? false : true}
              >
                <Nav.Link
                  active={getActivePage("background")}
                  className={
                    userData.backgroundInfo ? "complete" : "in-progress"
                  }
                >
                  {t("nav.backgroundInformation")}
                </Nav.Link>
              </LinkContainer>
            </section>

            {/* Phase 3  */}
            <section>
              <p className={enablePhases.phase3 ? "" : "phase-disabled"}>
                {t("nav.phase3")}
              </p>
              <LinkContainer
                to={"phase3-submit-application"}
                disabled={enablePhases.phase3 ? false : true}
              >
                <Nav.Link
                  active={getActivePage("submit")}
                  className={
                    userData.applicantStatus === "complete" || userData.applicantStatus === "newDoc" || userData.applicantStatus === "synced"
                      ? "complete"
                      : "in-progress"
                  }
                >
                  {t("nav.submitApplication")}
                </Nav.Link>
              </LinkContainer>
            </section>

            {/* Phase 4 */}
            <section>
              <p
                className={enablePhases.phase4 ? "" : "phase-disabled"}
                style={{ marginBottom: "0", fontWeight: "800" }}
              >
                {t("nav.phase4")}
              </p>
              <LinkContainer
                to={"phase4-upload-documents"}
                disabled={enablePhases.phase4 ? false : true}
              >
                <Nav.Link
                  active={getActivePage("documents")}
                  className={
                    !docsRequired ? docsRequired === 0 
                      ? "complete"
                      : "in-progress": "in-progress"
                  }
                >
                  {userData.documents ? docsRequired === 0 ? t("nav.uploadDocumentsCompleted") : t("nav.uploadDocumentsCount", { count: docsRequired === undefined ? 4 : docsRequired }) : t("nav.uploadDocuments")}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer
                to={"phase3-submit-application"}
                disabled={enablePhases.phase4 ? false : true}
              >
                <Nav.Link
                  active={getActivePage("phase3-submit-application")}
                  className={
                    userData.documents
                      ? "documents"
                      : "in-progress"
                  }
                >
                  {t("nav.prerequisites")}
                </Nav.Link>
              </LinkContainer>
              {/* <NavDropdown
                title="Pre Requisites"
                id="nav-dropdown"
                disabled={enablePhases.phase4 ? false : true}
              >
                <NavDropdown.Item eventKey="4.1">Pre Req 1</NavDropdown.Item>
                <NavDropdown.Item eventKey="4.2">Pre Reg 2</NavDropdown.Item>
                <NavDropdown.Item eventKey="4.3">Pre Req 3</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item eventKey="4.4">LMS</NavDropdown.Item>
              </NavDropdown> */}
            </section>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </aside>
  );
}
